import { render, staticRenderFns } from "./discountCreate.vue?vue&type=template&id=14063901&scoped=true&lang=html&"
import script from "./discountCreate.vue?vue&type=script&lang=js&"
export * from "./discountCreate.vue?vue&type=script&lang=js&"
import style0 from "./discountCreate.vue?vue&type=style&index=0&id=14063901&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14063901",
  null
  
)

export default component.exports